import { App, Channel, PromotionalPage } from '@/services/types'
import { BuilderGetters, Profile, SecretKey } from './types'

const getters: BuilderGetters = {

  getApp(state): App | null {
    return state.app
  },
  getAppType(state): string {
    return state.appType
  },
  getAppSelectedType(state): string {
    return state.appSelectedType
  },
  getAppCurrencyType(state): string {
    return state.appCurrency
  },
  getProfile(state): Profile {
    return state.profile
  },
  getChannels(state): Channel[] {
    return state.channels
  },
  getPhone(state): string | undefined {
    return state.phone
  },
  getSecretKey(state): SecretKey | undefined {
    return state.secretKey
  },
  getPromotionalPage(state): PromotionalPage | undefined | null{
    return state.promotionalPage
  },
}

export default getters
